"use client";

import React from "react";
import classes from "./LandingSection.module.scss";
import ArrowWithTail from "@/assets/icons/ArrowWithTail";
import { formatDistanceToNow } from "date-fns";
import { useRouter } from "next/navigation";
import Image from "next/image";
import Link from "next/link";

type HeroBannerProps = {
  title?: string;
  category?: string;
  readTime?: string;
  excerpt?: string;
  ctaText?: string;
  featuredNewsToShow: any;
};

const LandingSection = ({ featuredNewsToShow }: HeroBannerProps) => {
  const router = useRouter();
  const readMoreClick = (slug: any) => {
    router.push(`/article/${slug}`);
  };

  const createdAt = featuredNewsToShow?.[0]?.createdAt;
  const formattedPostDate = createdAt
    ? formatDistanceToNow(new Date(createdAt)) + " ago"
    : "Date unavailable";

  return (
    <div className={classes["heroBanner"]}>
      <div className={classes["hero-content-container"]}>
        <div className={classes["featured"]}>
          <Link href={`/category/featured`} target="_blank">
            {featuredNewsToShow[0].categoryName}
          </Link>
        </div>
        <div className={classes["category"]}>
          {/* <Link href="/carbon-markets" className={classes["carbon-markets"]}>
             AI Infrastucture
          </Link>
          <div className={classes["seperator-dot"]}>•</div> */}
          <div className={classes["read-time"]}>{formattedPostDate}</div>
        </div>
        <h1
          className={classes["title"]}
          onClick={() => readMoreClick(featuredNewsToShow?.[0]?.slug || "")}
        >
          {featuredNewsToShow?.[0]?.title}
        </h1>

        <p className={classes["content"]}>
          {featuredNewsToShow?.[0]?.postExcerpt}
        </p>
        <a
          className={classes["read-more"]}
          onClick={() =>
            readMoreClick(
              featuredNewsToShow?.[0] ? featuredNewsToShow?.[0].slug : ""
            )
          }
        >
          Read more
          <span className={classes["icon"]}>
            <ArrowWithTail rotation={360} color={"#fff"} />
          </span>
        </a>
      </div>
      <div className={classes["image-container"]}>
        <Image
          src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${featuredNewsToShow?.[0]?.imageUrl}`}
          alt="Landing Img"
          layout="responsive"
          width={1200}
          height={800}
        />
      </div>
    </div>
  );
};

export default LandingSection;
